import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { clearAllBodyScrollLocks } from "body-scroll-lock";
import { motion, AnimatePresence } from "framer-motion";
import styles from "./Page.module.sass";
import Header from "../Header";
import Footer from "../Footer";
import ScrollReveal from "../ScrollReveal";

const Page = ({ children }) => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
        clearAllBodyScrollLocks();
    }, [pathname]);

    return (
        <div className={styles.page}>
            <Header />
            <ScrollReveal />
            <AnimatePresence mode="wait">
                <motion.div
                    key={pathname}
                    className={styles.inner}
                    initial={{ opacity: 0, y: 18 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -12 }}
                    transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
                >
                    {children}
                </motion.div>
            </AnimatePresence>
            <Footer />
        </div>
    );
};

export default Page;
